<div class="c-magicBagInfo">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-magicBagInfo__container">
    <span class="text title">{{ 'home.live-ops.magicbag.modal-info.title' | translate }}</span>

    <div class="c-magicBagInfo__explanation">
      <div class="explanation">
        <div
          class="image image-1"
          theming
          themingGroup="magicbag"
          themingAsset="step-one"
          [themingOverride]="magicBagInfoModalData?.data?.event?.assets"></div>

        @if (magicBagInfoModalData?.data?.minPurchase != 0) {
          <span class="text subtitle"
            >{{
              'home.live-ops.magicbag.modal-info.step-1' | translate: { x: magicBagInfoModalData?.data?.minPurchase }
            }}
            {{ magicBagInfoModalData?.data?.currencySymbol }}</span
          >
        } @else {
          <span class="text subtitle">{{ 'home.live-ops.magicbag.modal-info.step-1-1' | translate }}</span>
        }
      </div>

      <div
        class="arrow arrow-1"
        theming
        themingGroup="none"
        themingAsset="arrow"></div>

      <div class="explanation">
        <div
          class="image image-2"
          theming
          themingGroup="magicbag"
          themingAsset="step-two"
          [themingOverride]="magicBagInfoModalData?.data?.event?.assets"></div>
        <span class="text subtitle">{{ 'home.live-ops.magicbag.modal-info.step-2' | translate }}</span>
      </div>

      <div
        class="arrow arrow-2"
        theming
        themingGroup="none"
        themingAsset="arrow"></div>

      <div class="explanation">
        <div
          class="image image-3"
          theming
          themingGroup="magicbag"
          themingAsset="step-three"
          [themingOverride]="magicBagInfoModalData?.data?.event?.assets">
          <div class="c-magicbag__multiplier">
            <div
              class="c-magicbag__bag-icon"
              theming
              themingGroup="magicbag"
              themingAsset="bag-icon"
              [themingOverride]="magicBagInfoModalData?.data?.event?.assets"></div>
            <span class="text multiplier"
              >x{{ magicBagInfoModalData?.data?.event?.properties?.magicbagmultiplier }}</span
            >
          </div>

          <slotcom-display [classes]="['c-display--auto', 'c-display--magicbag', 'c-display--magicbag--reward']">
            <div
              displayIcon
              displayIconPos="left"
              class="c-display--coin"></div>
            <span>{{
              magicBagInfoModalData?.data?.rewardBonus | number: '1.0-0' : ('common.culture' | translate)
            }}</span>
          </slotcom-display>
        </div>
        <span class="text subtitle">{{
          'home.live-ops.magicbag.modal-info.step-3'
            | translate: { x: magicBagInfoModalData?.data?.event?.properties?.magicbagmultiplier }
        }}</span>
      </div>
    </div>
  </div>
</div>
